import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

require('@babel/register')

ReactDOM.render(<App />,document.querySelector('#root'));